import type { ReactNode } from 'react';
import { RevenueCatProvider } from './RevenueCatProvider';
import { SubscriptionProvider } from './SubscriptionProvider';
import { WorkspaceProvider } from './WorkspaceProvider';

export function ProtectedAppProvidersShared({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <WorkspaceProvider>
      <RevenueCatProvider>
        <SubscriptionProvider>{children}</SubscriptionProvider>
      </RevenueCatProvider>
    </WorkspaceProvider>
  );
}
